import axios from 'axios';
import Settings from './config';
export default {
 
    checkStatus(id, arrivalDate, cb, errorCb) {
        axios.get(Settings.ENDPOINT + 'api/voucher/status/' + id + '/' + arrivalDate)
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                errorCb(response);
            });
    
    },
    getDetail(id, cb) {
        axios.get(Settings.ENDPOINT + 'api/voucher/detail/' + id)
            .then(response => {
                cb(response.data);
            });
    }
}

